const loginBtn = document.getElementById("loginBtn");
const passwordToggleIcon = document.querySelector(".password-toggle-icon");
const passwordInput = document.querySelector("#CustomerPassword");

passwordToggleIcon.addEventListener("click", () => {
  if (passwordInput.type === "password") {
    passwordInput.type = "text";
    passwordToggleIcon.querySelector(
      ".password-toggle-icon-show"
    ).hidden = true;
    passwordToggleIcon.querySelector(
      ".password-toggle-icon-hide"
    ).hidden = false;
  } else {
    passwordInput.type = "password";
    passwordToggleIcon.querySelector(
      ".password-toggle-icon-show"
    ).hidden = false;
    passwordToggleIcon.querySelector(
      ".password-toggle-icon-hide"
    ).hidden = true;
  }
});

const shopDomain = "iqrup-and-ritz.myshopify.com";
const storefrontAccessToken = "2032bbfa3cdb1326b287f5aeb2926c10";
const apiVersion = "2025-01";

// GraphQL endpoint URL
const endpoint = `https://${shopDomain}/api/${apiVersion}/graphql.json`;

console.log("API endpoint:", endpoint);

loginBtn.addEventListener("click", async (e) => {
  const email = document.getElementById("CustomerEmail").value;
  const password = document.getElementById("CustomerPassword").value;

  // GraphQL mutation for customer access token (Storefront API)
  const query = `
    mutation customerAccessTokenCreate {
      customerAccessTokenCreate(input: {
        email: "${email}",
        password: "${password}"
      }) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
  `;

  // Create both fetch promises
  const formPromise = fetch("/account/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      form_type: "customer_login",
      utf8: "✓",
      "customer[email]": email,
      "customer[password]": password,
    }),
  });

  const apiPromise = fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
    },
    body: JSON.stringify({ query }),
  });

  try {
    // Run both fetch requests concurrently
    const [formRes, apiRes] = await Promise.all([formPromise, apiPromise]);

    console.log("Form login response status:", formRes.status);

    // Process GraphQL API result
    const data = await apiRes.json();
    console.log("Storefront API response:", data);

    if (
      data.data?.customerAccessTokenCreate?.customerAccessToken?.accessToken
    ) {
      // Store access token in localStorage
      const token =
        data.data.customerAccessTokenCreate.customerAccessToken.accessToken;
      const expiresAt =
        data.data.customerAccessTokenCreate.customerAccessToken.expiresAt;

      localStorage.setItem("customerAccessToken", token);
      localStorage.setItem("tokenExpiresAt", expiresAt);

      console.log("Customer access token stored successfully");
      //   window.location.href = "/account";
    } else {
      // Handle login errors
      const errors =
        data.data?.customerAccessTokenCreate?.customerUserErrors || [];
      if (errors.length > 0) {
        console.error("Login errors:", errors);
        alert(`Login failed: ${errors[0].message}`);
      } else {
        console.error("Unknown login error");
        alert("Login failed. Please try again.");
      }
    }

    // Process form login result
    if (formRes.ok && apiRes.ok) {
      console.log("login successful");
      window.location.href = "/account";
    }
  } catch (error) {
    // Handle any errors from either promise
    console.error("Login request error:", error);
    alert("Login request failed. Please try again.");
  }
});
